import {
  STORAGE_KEY_PENDING_SEARCHSPRING_ANCHOR,
  installPlpFacetFilterScrollCapture,
} from "../plpFacetScrollMarkers";

export function afterStore(controller) {
  controller.on("init", async ({ controller }, next) => {
    installPlpFacetFilterScrollCapture();
    controller.log.debug("initialization...");
    await next();
  });
  controller.on("restorePosition", async (_ctx, next) => {
    await next();
    if (typeof sessionStorage === "undefined") return;

    const shouldAnchorRoot = sessionStorage.getItem(STORAGE_KEY_PENDING_SEARCHSPRING_ANCHOR);
    sessionStorage.removeItem(STORAGE_KEY_PENDING_SEARCHSPRING_ANCHOR);

    if (!shouldAnchorRoot) return;

    const root =
      typeof document !== "undefined" ? document.getElementById("searchspring-content") : null;
    if (!root) return;

    requestAnimationFrame(() => {
      root.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
  });
  controller.on("afterStore", async ({ controller: { store } }, next) => {
    mutateFacets(store.facets);
    // mutateResults(store.results);

    await next();
  });

  // log the store
  controller.on("afterStore", async ({ controller }, next) => {
    controller.log.debug("store", controller.store.toJSON());
    await next();
  });

  controller.on("afterStore", scrollToTop);
}

function mutateFacets(facets) {
  // for (let facet of facets) {
  //   let limit = 12;
  //   if (facet.display == "palette" || facet.display == "grid") {
  //     limit = 16;
  //   }

  //   facet.overflow?.setLimit(limit);
  // }
}

export async function scrollToTop(search, next) {
  // window.scroll({ top: 0, left: 0, behavior: "smooth" });
  // await next();
}
